import {Client} from "@/endpoints/rutsolve/gql/resolvers/client"
import {
    ContactDetails as ContactDetailsModel,
    CreateContactDetailsDocument,
    UpdateContactDetailsDocument,
    RemoveContactDetailsDocument,
    CreateContactDetailsMutationVariables,
    RemoveContactDetailsMutationVariables,
    UpdateContactDetailsMutationVariables
} from "@/endpoints/rutsolve/gql/generated/graphql"

export class ContactDetails extends Client {
    constructor() {
        super()
    }

    public async create(input: ContactDetailsModel) {
        try {
            const variables: CreateContactDetailsMutationVariables = {
                input: {
                    address: input.address,
                    city: input.city,
                    country: input.country,
                    email: input.email,
                    forename: input.forename,
                    phone: input.phone,
                    postalCode: input.postalCode,
                    priority: input.priority,
                    relationID: input.relationID,
                    relationType: input.relationType,
                    surname: input.surname,
                    surnamePrefix: input.surnamePrefix,
                    type: input.type,
                    website: input.website,
                }
            }
            await this.client.request(CreateContactDetailsDocument, variables)
        } catch (error) {
            this.handleError(error)
        }
    }

    public async update(input: ContactDetailsModel) {
        try {
            const variables: UpdateContactDetailsMutationVariables = {
                input: {
                    address: input.address,
                    city: input.city,
                    country: input.country,
                    email: input.email,
                    forename: input.forename,
                    id: input.id,
                    phone: input.phone,
                    postalCode: input.postalCode,
                    priority: input.priority,
                    surname: input.surname,
                    surnamePrefix: input.surnamePrefix,
                    type: input.type,
                    website: input.website,
                }
            }
            await this.client.request(UpdateContactDetailsDocument, variables)
        } catch (error) {
            this.handleError(error)
        }
    }

    public async remove(contactDetailsID: string) {
        try {
            const variables: RemoveContactDetailsMutationVariables = {
                contactDetailsID: contactDetailsID,
            }
            await this.client.request(RemoveContactDetailsDocument, variables)
        } catch(error) {
            this.handleError(error)
        }
    }
}
